import React, { FC } from 'react';

import Text from '../../text/text';
import { LucidTheme } from '../../../types/types';

export interface ErrorMessageProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** A specified message to be shown under the form input. */
  customErrorMessage?: string;
  /** The id of the form element that the error message is linked to. */
  id?: string;
  /** Checks if the component is a checkbox. */
  isCheckbox?: boolean;
  /** Checks if the field is disabled. */
  isDisabled?: boolean;
}

const ErrorMessage: FC<ErrorMessageProps> = ({
  className,
  customErrorMessage = '',
  id,
  isCheckbox = false,
  isDisabled = false,
  ...rest
}) => (
  <Text
    {...rest}
    as="span"
    css={(theme: LucidTheme) => [
      {
        label: 'errorMessage',
        color: theme.colors.pink[60],
      },
      isCheckbox && {
        order: 4,
        width: '100%',
      },
      isDisabled && {
        color: theme.colors.pink[40],
      },
    ]}
    // eslint-disable-next-line react/jsx-sort-props
    className={className}
    data-testid={`formErrorMessage-${id}`}
    id={`errorMessage-${id}`}
    variant="labelXS400"
  >
    {customErrorMessage}
  </Text>
);

export { ErrorMessage };
export default ErrorMessage;
